export const GET_OWNER_INFO = "get_owner_info";
export const GET_OWNER_INFO_FAIL = "get_owner_info_fail";
export const GET_OWNER_INFO_SUCCESS = "get_owner_info_success";

export const UPDATE_OWNER_INFO = "update_owner_info";
export const UPDATE_OWNER_INFO_FAIL = "update_owner_info_fail";
export const UPDATE_OWNER_INFO_SUCCESS = "update_owner_info_success";
